import { Link } from "react-router-dom";

function Right() {
  return (
    <>
      <div className="col-lg-4 col-12  d-lg-block d-none">
        <div className="p-4 bg-light-red shadow rounded-4 sticky-top header-gap z-0">
          <div className="text-center mb-3">
            <h3 class="mb-0 lh-1 mt-2 fw-medium">
              You are <span className="text-danger">missing</span> out on the
              <br />
              premium benefits!
            </h3>
          </div>
          <div className="pe-6 ps-2 py-2 rounded-pill bg-white mb-1">
            <div className="d-flex align-items-center">
              <div class="icon-shape icon-lg bg-light-primary rounded-circle">
                <i class="bi bi-people fs-3 text-primary"></i>
              </div>
              <div className="ms-3">
                <h3 class="mb-0 text-dark lh-1 fs-5">
                  Verified & Genuine Profiles
                </h3>
                <span className="text-secondary">
                  Every profile is carefully reviewed
                </span>
              </div>
            </div>
          </div>
          <div className="pe-6 ps-2 py-2 rounded-pill bg-white mb-1">
            <div className="d-flex align-items-center">
              <div class="icon-shape icon-lg bg-light-primary rounded-circle">
                <i class="bi bi-heart fs-3 text-primary"></i>
              </div>
              <div className="ms-3">
                <h3 class="mb-0 text-dark lh-1 fs-5">
                  Personalized Matchmaking
                </h3>
                <span className="text-secondary">
                  Our intelligent matching system
                </span>
              </div>
            </div>
          </div>
          <div className="pe-6 ps-2 py-2 rounded-pill bg-white mb-1">
            <div className="d-flex align-items-center">
              <div class="icon-shape icon-lg bg-light-primary rounded-circle">
                <i class="bi bi-lightning fs-3 text-primary"></i>
              </div>
              <div className="ms-3">
                <h3 class="mb-0 text-dark lh-1 fs-5">Privacy & Security</h3>
                <span className="text-secondary">
                  Your personal data is protected
                </span>
              </div>
            </div>
          </div>
          <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
            <div className="d-flex align-items-center">
              <div class="icon-shape icon-lg bg-light-primary rounded-circle">
                <i class="bi bi-camera fs-3 text-primary"></i>
              </div>
              <div className="ms-3">
                <h3 class="mb-0 text-dark lh-1 fs-5">
                  Matches Across Communities
                </h3>
                <span className="text-secondary">
                  Find matches across communities
                </span>
              </div>
            </div>
          </div>

          <div>
            <p className="mb-1 mt-3 fs-6 text-center text-dark">
              Get Flat 75% OFF till 24 December
            </p>
            <Link
              to="/upgrade"
              className="btn bg-red-primary text-white fw-normal rounded-pill px-5 w-100"
            >
              Upgrade Now <i className="bi bi-arrow-right-circle-fill ms-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Right;
